export default __webpack_public_path__ + "static/media/INL-SWI.a973151b.png";